// eslint-disable-next-line import/prefer-default-export
export function makeCustomerNumber(customerNumber, apfId) {
  return apfId ? `${customerNumber}-${apfId}` : customerNumber;
}
